import { Navigate, useLocation } from 'react-router-dom';
import { getMustChangePassword } from '../../services/authService';

export default function ProtectedRoute({ children }) {
    const token = localStorage.getItem("token");
    const location = useLocation();

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (getMustChangePassword() && location.pathname !== '/promjena-lozinke') {
        return <Navigate to="/promjena-lozinke" replace />;
    }

    return children;
}